module.exports = __webpack_public_path__ + "media/images/features_drawing-9a1ed00bf2b2640f4f8de5a10d21cf73.png";